var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('scoring-input',_vm._g({attrs:{"id":`scores-1`},model:{value:(_vm.value),callback:function ($$v) {_vm.value=_vm._n($$v)},expression:"value"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }